import _ from 'lodash';
import { determineErrorFromResponse, determineErrorIfStaticRender } from 'helpers/ContentHelper';
import { FETCH_PROMO_LIST } from './PromoListActions';

const INITIAL_STATE = {
  panels: null,
  seo: null,
  errors: null,
};

export default function(state = INITIAL_STATE, action) {
  let errors = determineErrorFromResponse(action);
  if (errors) {
    return {
      ...state,
      errors,
    };
  }
  const data = _.get(action, 'payload.data', null);
  const panels = _.get(data, 'panels', null);
  const seo = _.get(data, 'SEO', null);
  switch (action.type) {
    case FETCH_PROMO_LIST:
      if (!panels) errors = determineErrorIfStaticRender();
      return {
        ...state,
        panels,
        seo,
        errors,
      };
    default:
      return state;
  }
}
